import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UnitTypesService } from '@modules/settings/unit-types/unit-types.service';

@Pipe({
  name: 'meter',
  standalone: true
})
export class MeterPipe implements PipeTransform {

  translate = inject(TranslateService);

  transform(meter: any): string {
    if (!meter) {
      return '';
    }
    const unitType = meter.utilityProviderType?.unitType;
    const unitTypeName = UnitTypesService.getName(this.translate.currentLang, unitType?.translates);
    return `${this.translate.instant('CITY.CODE')}: ${meter.meterNumber}, ${this.translate.instant('RESIDENTS.TYPE')}: ${unitTypeName}`;
  }
}
